import React from 'react';
import P from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Redirect, Link } from "react-router-dom";

import { ThemeContext } from 'components/App/';
import Label from 'components/Label/';
import Sidebar from 'components/Sidebar/';
import PartnershipStatus from 'components/group/PartnershipStatus/';
import { GROUPS_LIST_QUERY } from 'gql/queries';
import ensureLoggedIn from 'utils/ensureLoggedIn';
import displayLoading from 'utils/displayLoading';
import config from 'config';

import './GroupsList.scss';

const IMG_SIZE = 60;

const GroupsList = ({ data }) => {
  const { groupsAdministered } = data.store.user;

  if (groupsAdministered.length === 1) {
    return <Redirect to={`/group/${groupsAdministered[0].id}/opportunities`} />;
  }

  return (
    <ThemeContext.Consumer>
    {
      ({ VRCId, hideRequestPartnership }) => {
        return (
          <div className="GroupsList">
            <div className="GroupsList-main">
              <h2 className="GroupsList-heading">My groups</h2>
              <div className="GroupsList-list">
                {
                  groupsAdministered.map(g => {
                    return (
                      <Link to={`/group/${g.id}/opportunities`} key={g.id}>
                        <div className="GroupsList-list-item">
                          <div className="GroupsList-list-item-name">
                            <img src={`${config.IMG_URL}${g.avatarUrl}?fit=clamp&h=${IMG_SIZE}&w=${IMG_SIZE}`} alt="" />
                            {g.name}
                            {g.draft && <Label className="ml-2">Draft</Label>}
                          </div>
                          {!g.draft && !hideRequestPartnership && <PartnershipStatus requesterId={g.id} requesteeId={VRCId} />}
                        </div>
                      </Link>
                    );
                  })
                }
              </div>
            </div>
            <div className="GroupsList-aside">
              <Sidebar />
            </div>
          </div>
        );
      }
    }
    </ThemeContext.Consumer>
  );
};

GroupsList.propTypes = {
  data: P.shape({
    store: P.shape({
      user: P.shape({
        groupsAdministered: P.arrayOf(
          P.shape({
            id: P.string.isRequired,
            name: P.string.isRequired,
            avatarUrl: P.string,
          }),
        ).isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default compose(
  graphql(GROUPS_LIST_QUERY),
  ensureLoggedIn,
  displayLoading(),
)(GroupsList);
